import { ref } from 'vue';
import Psd from '@webtoon/psd';
import { ImportLayersElements } from '@/typings/layers/layers';
import { FileParserContext } from '@/parsers/FileParserContext';
import { PsdFileParser } from '@/parsers/PsdFileParser';
import { CanvaFileParser } from '@/parsers/CanvaFileParser';
import { ZipReader } from '@zip.js/zip.js';
import { FileParserType } from '@/typings/parsers/fileParserTypes';

export const useFileLayers = (fileType: FileParserType) => {
    const data = ref<ImportLayersElements | null>(null);
    let parserContext: FileParserContext<any>;

    switch (fileType) {
        case 'PSD':
            parserContext = new FileParserContext<Psd>(new PsdFileParser());
            break;
        case 'CANVA':
            parserContext = new FileParserContext<ZipReader<Blob>>(new CanvaFileParser());
            break;
        default:
            throw new Error(`Unsupported file type: ${fileType}`);
    }

    const parseAndExtractLayers = async (buffer: ArrayBuffer, payload = {} as ImportLayersElements) => {
        try {
            data.value = await parserContext.parseAndExtractLayers(buffer, payload);
        } catch (error) {
            console.error('Error processing file:', error);
        }
    };

    return { data, parseAndExtractLayers };
};
